import { ModelBase } from "../core/modelbase";

export class GlobalSetting extends ModelBase {
  gsKey: string;
  gsName: string;
  gsContent: string;
}
